import { gql } from "urql";
export const GetPostalCodeCountQuery = gql `
    query GetPostalCodeCount($search: String) {
        postalCodes {
            postalCodeCount(search: $search)
        }
    }
`;
export const GetPostalCodesQuery = gql `
    query GetPostalCodes($search: String, $offset: Int) {
        postalCodes {
            postalCodes(search: $search, offset: $offset) {
                postalCodeId
                postalCode
                latitude
                longitude
                city
                stateId
                stateName
                countyName
                timezone
                isActive
                createdAt
                updatedAt
            }
        }
    }
`;
export const GetPostalCodeQuery = gql `
    query GetPostalCode($postalCodeId: String, $postalCode: String) {
        postalCodes {
            postalCode(postalCodeId: $postalCodeId, postalCode: $postalCode) {
                postalCodeId
                postalCode
                latitude
                longitude
                city
                stateId
                stateName
                countyName
                timezone
                isActive
            }
        }
    }
`;
